module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAAN0lEQVRIiWM07f//n4GOgImeljGMWkgLwMLAwMBIQ/MxEuRoohm1cNTCUQtHLRy1cMRbyMDAAADRVgPwe5SYTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/border_2.png
// module id = ++PL
// module chunks = 1